import axios from 'axios'
import Cookies from 'js-cookie'
import qs from 'qs'
import isPlainObject from 'lodash/isPlainObject'
import router from '../components/router'
import {baseUrl} from './'
const http = axios.create({
  baseURL: baseUrl,
  timeout: 1000 * 180,
  withCredentials: true,
  headers: {'User-Agent': 'wizdomUA'}
})

/**
 * 请求拦截
 */
http.interceptors.request.use((config) => {
  // eslint-disable-next-line no-param-reassign
  config.headers['Accept-Language'] = Cookies.get('language') || 'zh-CN'
  // 默认参数
  const defaults = {}
  // 防止缓存，GET请求默认带_t参数
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...{ _t: new Date().getTime()}
    }
  }
  if (isPlainObject(config.params)) {
    config.params = {
      ...defaults,
      ...config.params
    }
  }
  if (isPlainObject(config.data)) {
    config.data = {
      ...defaults,
      ...config.data
    }


    if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
      config.data = qs.stringify(config.data)
    }
  }
  return config
}, (error) => Promise.reject(error))

/**
 * 响应拦截
 */
http.interceptors.response.use((response) => {
  if (response.data.code === 401 || response.data.code === 10001) {
    clearLoginInfo()
    router.replace({ name: 'login' })
    return Promise.reject(response.data.msg)
  }
  return response
}, (error) => {
  console.error(error)
  return Promise.reject(error)
})

export default http
